import { UserRole } from "@joonapp/web-shared"

import { useFamilyQuery } from "../../networking/queries"
import ChildPage from "../family/childUser/ChildPage"
import useFamilyUserSelectStore from "../family/hooks/useFamilyUserSelect"
import ParentPage from "../family/parentUser/ParentPage"

const FamilyUserPage = () => {
  const { data: family } = useFamilyQuery()
  const { selectedUserId } = useFamilyUserSelectStore()

  if (!family || !selectedUserId) return null

  const selectedUser = family.profiles.find(
    (profile) => profile.user.id === selectedUserId
  )

  if (!selectedUser) return null

  if (selectedUser.role === UserRole.PARENT) return <ParentPage />
  else return <ChildPage />
}

export default FamilyUserPage
